export const navItems = [
    {
        name: 'Industry Leader',
        href: '/industry-leader',
        children: [
            {
                name: 'Industry News',
                href: '/industry-leader/news'
            },
            {
                name: 'Large Financial Firms',
                href: '/industry-leader/large-firms'
            },
            {
                name: 'Universities',
                href: '/industry-leader/universities'
            },
            {
                name: 'Ministries',
                href: '/industry-leader/ministries'
            },
            {
                name: 'Product and Service Providers',
                href: '/industry-leader/products-services'
            },
            {
                name: 'Sponsors',
                href: '/sponsors'
            },
            {
                name: 'Prospects and Clients',
                href: '/industry-leader/prospects-clients'
            },
        ]
    },
    {
        name: 'Join Our Community',
        href: '/community',
        children: [
            {
                name: 'Membership',
                href: 'https://membership.kingdomadvisors.com/',
            },
            {
                name: 'Study Groups',
                href: '/community/study-groups',
                children: [
                    {
                        name: 'Find a Study Group',
                        href: '/community/study-groups/find-a-study-group',
                    },
                    {
                        name: "This Month's Study Group Topic",
                        href: '/community/study-groups/current-topic',
                    },
                    {
                        name: 'Virtual Study Groups',
                        href: '/community/study-groups/virtual-study-groups'
                    }
                ]
            },
            {
                name: 'KA Communities',
                href: 'https://app.kingdomadvisors.com/communities',
                external: true,
            },
        ],
    },
    {
        name: 'Events',
        href: '/events',
        children: [
            {
                name: 'Kingdom Advisors Conference',
                href: 'https://kingdomadvisorsconference.com',
                external: true,
            },
            {
                name: 'Beyond the Great Wealth Transfer Digital Event',
                href: 'https://events.kingdomadvisors.com/',
                external: true,
            },
            {
                name: 'Virtual Events',
                href: '/events/virtual-events'
            },
            {
                name: 'Champions Forum',
                href: 'https://events.kingdomadvisors.com/champions-forum',
                external: true,
            },
            {
                name: ' Champions Mastermind Program',
                href: '/events/champions-mastermind-program'
            },
            {
                name: 'Canada Regional Events',
                href: '/events/canada-regional-events'
            },
        ]
    },
    {
        name: 'Find a CKA®',
        href: '/find-a-cka',
        children: [
            {
                name: 'CKA® Directory Search',
                href: '/find-a-cka/cka-directory-search'
            },
            {
                name: 'Choosing your CKA®',
                href: '/find-a-cka/choosing-your-cka'
            },
        ]
    },
    {
        name: 'Get Certified',
        href: '/get-certified',
        children: [
            {
                name: 'Why Become a CKA®',
                href: '/become-a-cka',
            },
            {
                name: 'Steps to Get Certified: US',
                href: '/get-certified/steps-to-get-certified',
            },
            {
                name: 'Steps to Get Certified: Canada',
                href: '/get-certified/steps-to-get-certified-canada'
            },
            {
                name: 'CKA® Educational Program',
                href: '/get-certified/cka-educational-program'
            },
            {
                name: 'Kingdom Advisors Core Training',
                href: '/get-certified/core-training'
            }
        ]
    }
];
